import moment from "moment";

const phoneValidation = (value) => {
  value = value.replace(/\D/g, "");
  return value;
};

const ageValidation = (value, min, max) => {
  var regExp = /[a-zA-Z]/g;
  var flag = regExp.test(value);
  var errorMsg = "";
  if (value === "") {
    return {
      valid: false,
      age: -3,
      errorMsg: errorMsg,
    };
  } else if (!flag) {
    var years = moment().diff(moment(value, "DD/MM/YYYY"), "years");
    var days =
      years === 0 && min === 0
        ? moment().diff(moment(value, "DD/MM/YYYY"), "days")
        : 1;
    // console.info('Days :', days)
    if (days > 0) {
      if (years > max || years < min) {
        years = -2;
        errorMsg = `This option is available only for age between ${min} to ${max} years.`;
      } else if (Math.sign(years) === -1) {
        years = -1;
        errorMsg = "Enter valid date of birth";
      } else if (isNaN(parseFloat(years))) {
        years = -1;
        errorMsg = "Enter valid date of birth";
      }
      return {
        valid: true,
        age: years,
        errorMsg: errorMsg,
      };
    } else {
      years = -2;
      errorMsg = `This option is available only for age between ${min} to ${max} years.`;
      return {
        valid: true,
        age: years,
        errorMsg: errorMsg,
      };
    }
  } else {
    return {
      valid: false,
      age: -1,
      errorMsg: errorMsg,
    };
  }
};

const emailValidation = (value) => {
  var regExp =
    /^(?=.{5,50}$)(?!.*?[._-]{2})[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){0,1}\.[a-zA-Z]{2,12}$/.test(
      value,
    );
  var negativeEmail = [
    "buyonline@icicilife.com",
    "lifeline@icicilife.com",
    "bolescalation@icicilife.com",
  ];
  var errorMsg = "";
  if (regExp && !negativeEmail.includes(value)) {
    return {
      valid: true,
      email: value,
      errorMsg: errorMsg,
    };
  } else {
    return {
      valid: false,
      email: value,
      errorMsg: "Enter valid email id",
    };
  }
};

const getKeyByValueOfJson = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

const getValueByKeyOfJson = (object, keyVal) => {
  for (var key in object) {
    if (key == keyVal) return object[key];
  }
  return "";
};

export {
  phoneValidation,
  ageValidation,
  emailValidation,
  getKeyByValueOfJson,
  getValueByKeyOfJson,
};
